<template lang="html">
  <button class="btn btn-appt-select d-flex justify-content-between align-items-center"">
    <span class="icon-indicators">
      <i v-if="encounter && encounter.allSetupTasksCompleted" class="fas fa-check color-green"></i>
    </span>
    <span class="apt-content flex-grow-1">
      <strong>{{ appointment.AptDateTime | prettyTimeFromDT }}</strong>
      <span v-if="appointment.PatientName">
        <span class="pt-name-label">Patient Name</span>
        <span class="pt-name">{{ appointment.PatientName }}</span>
      </span>
    </span>
    <i class="fas fa-angle-right"></i>
  </button>
</template>

<script>
export default {
  props: ['appointment','encounter'],
  data() {
    return {
      checklistComplete: false,
    };
  },
  watch: {
    appointment(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.loadAppoinmentMeta();
      }
    },
  },
  methods: {
    async loadAppoinmentMeta() {
      // TODO: after appointment setup page is built
      // load data from firebase for appointment for all possible encounter types
      // check if any has a checklist compelte
      // if so, set checklistComplete to true
    },
  },
}
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";

.btn-appt-select {
  background-color: @light-color;
  border: 1px solid @dim-color !important;
  text-align: left;
  padding: 20px;
  width: 100%;
  margin-bottom: 10px;

  .apt-content {
    padding-right: 20px;
    padding-left: 10px;

    span,
    strong {
      display: block;
    }
  }
  .apt-content > span {
    font-size: 18px;
    line-height: 18px;
  }
  .apt-content > strong {
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 15px
  }
  .fas {
    text-align: right;
  }
  .pt-name-label {
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 400;
  }
  .pt-name {
    font-size: 16px;
    font-weight: 400;
  }
  &:hover {
    background-color: @color-green;
    border: 3px solid @color-salmon, 1px solid @light-color !important;

    .fas.color-green {
      color: @light-color !important;
      transform: rotate(0deg);
      transition: none;
      transition: color 250ms ease-in-out;
    }
  }
}
</style>
